<section class="content-side mb-30 bg-white">
  <div class="header">
    <div class="mb-30 content-header">
      <h1 class="title-header mb-10">{{ "ContactUs" | translate }}</h1>
    </div>
    <div class="logo-m247">
      <img alt="logo" [src]="urlIMG + 'logo-m247-color.png'" />
    </div>
  </div>

  <nz-divider></nz-divider>

  <div nz-col nzSpan="24" class="mt-30">
    <div
      class="description-policies"
      [innerHTML]="'FormContact.text1' | translate"
    ></div>
  </div>

  @if (!loadMessage) {
  <div nz-row>
    <div nz-col nzSpan="24" class="mt-30">
      <form nz-form [formGroup]="validateForm">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="name" nzRequired>
            {{ "FormContact.Name" | translate }}:
          </nz-form-label>
          <nz-form-control
            [nzSpan]="24"
            nzHasFeedback
            nzErrorTip="{{ 'FormValid.NameRequired' | translate }}"
          >
            <input
              nz-input
              id="name"
              formControlName="name"
              type="text"
              [maxlength]="200"
              [disabled]="sendingEmail"
            />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="email">
            {{ "FormContact.Email" | translate }}:
          </nz-form-label>
          <nz-form-control
            [nzSpan]="24"
            nzHasFeedback
            [nzErrorTip]="emailErrorTpl"
          >
            <input
              nz-input
              formControlName="email"
              type="email"
              id="email"
              [disabled]="sendingEmail"
              (ngModelChange)="validateConfirmEmail()"
            />
            <ng-template #emailErrorTpl let-control>
              @if (control.hasError('email')) {
              {{ "FormValid.EmailNotValid" | translate }}
              } @if (control.hasError('required')) {
              {{ "FormValid.EmailRequired" | translate }}
              }
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="emailConfirm">
            {{ "FormContact.EmailConfirm" | translate }}:
          </nz-form-label>
          <nz-form-control
            [nzSpan]="24"
            nzHasFeedback
            [nzErrorTip]="emailConfirmErrorTpl"
          >
            <input
              nz-input
              type="email"
              formControlName="emailConfirm"
              id="emailConfirm"
              [disabled]="sendingEmail"
            />
            <ng-template #emailConfirmErrorTpl let-control>
              @if (control.hasError('required')) {
              {{ "FormValid.EmailConfirm" | translate }}
              } @if (control.hasError('confirm')) {
              {{ "FormValid.EmailNotEqual" | translate }}
              }
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="reason">
            {{ "FormContact.Reason" | translate }}:
          </nz-form-label>
          <nz-form-control
            [nzSpan]="24"
            nzHasFeedback
            nzErrorTip="{{ 'FormValid.ReasonRequired' | translate }}"
          >
            <nz-select
              id="reason"
              formControlName="reason"
              nzAllowClear
              nzPlaceHolder="Choose"
              [disabled]="sendingEmail"
            >
              <nz-option
                nzValue="{{ 'FormContact.RequestInformation' | translate }}"
                nzLabel="{{ 'FormContact.RequestInformation' | translate }}"
              ></nz-option>
              <nz-option
                nzValue="{{ 'FormContact.Failes' | translate }}"
                nzLabel="{{ 'FormContact.Failes' | translate }}"
              ></nz-option>
              <nz-option
                nzValue="{{ 'FormContact.RemoveAccountIos' | translate }}"
                nzLabel="{{ 'FormContact.RemoveAccountIos' | translate }}"
              ></nz-option>
              <nz-option
                nzValue="{{ 'FormContact.Other' | translate }}"
                nzLabel="{{ 'FormContact.Other' | translate }}"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="description">
            {{ "FormContact.Description" | translate }}:
          </nz-form-label>
          <nz-form-control
            [nzSpan]="24"
            nzHasFeedback
            nzErrorTip="{{ 'FormValid.DescriptionRequired' | translate }}"
          >
            <nz-textarea-count [nzMaxCharacterCount]="1000">
              <textarea
                formControlName="description"
                id="description"
                nz-input
                rows="3"
                [disabled]="sendingEmail"
              ></textarea>
            </nz-textarea-count>
          </nz-form-control>
        </nz-form-item>

        <nz-divider></nz-divider>

        <div nz-col nzSpan="24" class="btn-submit">
          <button nz-button nzType="primary" (click)="submitForm()">
            {{ "Send" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
  } @if (loadMessage) {
  <div nz-row>
    <div nz-col nzSpan="24">
      <nz-result nzStatus="success" nzTitle="{{ 'SendingEmail' | translate }}">
        <div nz-result-extra>
          <button nz-button nzType="primary" [routerLink]="['/']">
            {{ "Back" | translate }}
          </button>
        </div>
      </nz-result>
    </div>
  </div>
  }
</section>
